<template>
    <svg :class="className" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1l7 7m0 0l7 7M8 8l7-7M8 8l-7 7" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>

